<div class="banner d-lg-flex d-none">
  <h1>{{ 'events.page.title' | translate }}</h1>
</div>

<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-4">
  <fgbcl-marketplace-list
    [isList]="true"
    [showSortBar]="false"
    [marketplaceItemTypes]="[3, 5]"
    [eventItemView]="true"
    [defaultSort]="2"
  ></fgbcl-marketplace-list>
</div>
